import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import update from "immutability-helper";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useDebounce } from "hooks";
import { Div, FilterButton, Fieldset } from "@base-ui";
import { extendedSystemStylesProps } from "@mixins";
import { DragItem } from "./DragItem";
import { jsx as _jsx } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox"];

//use when you can check multiple filters with drag and drop
var DraggableFilterFieldset = function DraggableFilterFieldset(props) {
  var id = props.id,
    legend = props.legend,
    hideLegend = props.hideLegend,
    options = props.options,
    selected = props.selected,
    updateSelected = props.updateSelected,
    icon = props.icon,
    className = props.className,
    updateOrder = props.updateOrder,
    _props$debounce = props.debounce,
    debounce = _props$debounce === void 0 ? 1000 : _props$debounce;
  var _useState = useState(options),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  useEffect(function () {
    return setItems(options);
  }, [options]);
  useDebounce(items, debounce, updateOrder);
  var moveItem = useCallback(function (dragIndex, hoverIndex) {
    setItems(function (prevItems) {
      return update(prevItems, {
        $splice: [[dragIndex, 1], [hoverIndex, 0, prevItems[dragIndex]]]
      });
    });
  }, []);
  var filters = items.map(useCallback(function (option, index) {
    return /*#__PURE__*/_jsx(DragItem, {
      index: index,
      id: option.id,
      moveItem: moveItem,
      children: /*#__PURE__*/_jsx(FilterButton, {
        id: "".concat(id, "-filter-").concat(option.id),
        className: className,
        label: option.label,
        checked: selected.includes(option.id),
        onChange: function onChange(check) {
          return updateSelected(check, option.id);
        },
        style: {
          marginBottom: "5px",
          justifyContent: "space-between"
        }
      }, option.id)
    }, option.id);
  }, [className, id, moveItem, selected, updateSelected]));
  return /*#__PURE__*/_jsx(DndProvider, {
    backend: HTML5Backend,
    children: /*#__PURE__*/_jsx(Fieldset, _objectSpread(_objectSpread({
      legend: legend,
      hideLegend: hideLegend
    }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
      className: className,
      icon: icon,
      children: /*#__PURE__*/_jsx(Div, {
        children: filters
      })
    }))
  });
};
DraggableFilterFieldset.propTypes = {
  id: PropTypes.string.isRequired,
  legend: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  selected: PropTypes.array.isRequired,
  updateSelected: PropTypes.func.isRequired,
  hideLegend: PropTypes.oneOf([true, false]),
  icon: PropTypes.string,
  updateOrder: PropTypes.func.isRequired,
  debounce: PropTypes.number
};
export default DraggableFilterFieldset;